import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://stayku.onrender.com/',  // 백엔드 서버 주소
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터
axiosInstance.interceptors.request.use(
  (config) => {
    // 예: 토큰 추가
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 응답 인터셉터
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      alert('로그인이 필요합니다.');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
